import styled from 'styled-components'
import { darken, lighten, transparentize } from 'polished'

const Button = styled.button`
  display: flex;
  ${props => (props.block ? `width: 100%` : null)};
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.gray200};
  color: black;
  border: none;
  border-radius: 0.25rem;
  transition: all 250ms ease;
  cursor: pointer;
  &:hover {
    background-color: ${props => darken(0.05, props.theme.colors.gray200)};
  }
  &:active {
    background-color: ${props => lighten(0.05, props.theme.colors.gray200)};
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2pt
      ${props => transparentize(0.5, props.theme.colors.gray200)};
  }
`

const InteractiveButton = styled(Button)`
  background-color: ${props => props.theme.colors.interactive};
  color: white;
  &:hover {
    background-color: ${props => darken(0.05, props.theme.colors.interactive)};
  }
  &:active {
    background-color: ${props => lighten(0.05, props.theme.colors.interactive)};
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2pt
      ${props => transparentize(0.5, props.theme.colors.interactive)};
  }
`

const IconButton = styled(Button)`
  display: inline-flex;
  vertical-align: middle;
  height: auto;
  color: white;
  font-size: ${props => props.size}px;
  padding: 4px;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  i {
    color: ${props =>
      props.theme.colors[props.iconColor] ||
      props.iconColor ||
      props.theme.colors.gray800};
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`

IconButton.defaultProps = {
  size: 24
}

const LinkButton = styled(Button).attrs(props => ({
  appliedColor:
    props.theme.colors[props.color] || props.theme.colors.interactive
}))`
  background-color: transparent;
  color: ${props => props.appliedColor};

  &:hover {
    background-color: ${props => transparentize(0.9, props.appliedColor)};
  }
`

export default Button
export { IconButton, InteractiveButton, LinkButton }
